export function formatDate(dateString: string) {
  return new Intl.DateTimeFormat('de-DE').format(new Date(dateString));
}
